async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, init);
  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error((data as { error?: string } | null)?.error || `Request failed (${response.status})`);
  }

  return data as T;
}

export function getCompletedPaymentsCount() {
  return request<{ count: number }>('/api/count').then((data) => data.count);
}

export function createCheckout() {
  return request<{ url: string }>('/api/create-checkout', { method: 'POST' });
}

export type PaymentStatus = { status: string; created_at: string } | null;

export function getPaymentStatus(sessionId: string) {
  return request<{ payment: PaymentStatus }>(
    `/api/payment-status?session_id=${encodeURIComponent(sessionId)}`,
  ).then((data) => data.payment);
}

export type PaymentConfig = {
  publishableKey: string;
  amount: number;
  currency: string;
};

export function getPaymentConfig() {
  return request<PaymentConfig>('/api/config');
}

export function createPaymentIntent() {
  return request<{ clientSecret: string; paymentIntentId: string }>('/api/create-payment-intent', {
    method: 'POST',
  });
}

export function confirmPayment(paymentIntentId: string) {
  return request<{ paid: boolean; status?: string; created_at?: string }>('/api/confirm-payment', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ paymentIntentId }),
  });
}
